<template>
	<div v-if="pembayaran.length > 0">
		<div class="f-bold f-16 f-c-black m-d-16">
			Pembayaran
		</div>
		<div v-for="(p, i) in pembayaran" :key="i">
			<SOPembayaranTunai v-if="p.jenis_bayar === 1"
			                   :pembayaran="p"
			                   :tipeBayar="tipeBayar(p.tipe_bayar)"
			/>
			<SOPembayaranDebit v-if="p.jenis_bayar === 3"
			                   :pembayaran="p"
			                   :tipeBayar="tipeBayar(p.tipe_bayar)"
			/>
			<SOPembayaranEpayment v-if="p.jenis_bayar === 4"
			                      :pembayaran="p"
			                      :tipeBayar="tipeBayar(p.tipe_bayar)"
			/>
			<SOPembayaranDeposit v-if="p.jenis_bayar === 5" :pembayaran="p"/>
			<SOPembayaranPaylink v-if="p.jenis_bayar === 6"
			                     :pembayaran="p"
			                     :tipeBayar="tipeBayar(p.tipe_bayar)"
			/>
			<SOPembayaranQRIS v-if="p.jenis_bayar === 10"
			                  :pembayaran="p"
			                  :tipeBayar="tipeBayar(p.tipe_bayar)"
			/>
			<SOPembayaranEDC v-if="p.jenis_bayar === 11"
			                 :pembayaran="p"
			                 :tipeBayar="tipeBayar(p.tipe_bayar)"
			/>
		</div>
		<div class="separator-line-dot m-t-4 m-d-16"></div>
	</div>
</template>

<script>
import SOPembayaranTunai from "@/so-components/modules/transaksi/pembayaran/SOPembayaranTunai";
import SOPembayaranDebit from "@/so-components/modules/transaksi/pembayaran/SOPembayaranDebit";
import SOPembayaranEpayment from "@/so-components/modules/transaksi/pembayaran/SOPembayaranEpayment";
import SOPembayaranDeposit from "@/so-components/modules/transaksi/pembayaran/SOPembayaranDeposit";
import SOPembayaranPaylink from "@/so-components/modules/transaksi/pembayaran/SOPembayaranPaylink";
import SOPembayaranQRIS from "@/so-components/modules/transaksi/pembayaran/SOPembayaranQRIS";
import SOPembayaranEDC from "@/so-components/modules/transaksi/pembayaran/SOPembayaranEDC";

export default {
	name: "SOPembayaranList",
	components: {
		SOPembayaranTunai,
		SOPembayaranDebit,
		SOPembayaranEpayment,
		SOPembayaranDeposit,
		SOPembayaranPaylink,
		SOPembayaranQRIS,
		SOPembayaranEDC,
	},
	props: {
		pembayaran: Array,
	},
	methods: {
		tipeBayar(tipe) {
			if (tipe === 1) {
				return "Lunas"
			} else if (tipe === 2) {
				return "DP"
			} else {
				return "Pelunasan"
			}
		},
	}
}
</script>